import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-approval",
  "use": "icon-approval-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-approval\"><path d=\"M768 192H640c0-70.4-57.6-128-128-128s-128 57.6-128 128H256c-35.2 0-64 28.8-64 64v640c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64V256c0-35.2-28.8-64-64-64z m-256-32c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32z m256 736H256V256h64v64h384v-64h64v640z m-59.2-404.8L459.2 740l-45.6-45.6 248.8-248.8 46.4 45.6z m-340 68l136 136-45.6 45.6-136-136 45.6-45.6z\" p-id=\"7376\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/approval.svg
// module id = Fsqj
// module chunks = 80